function initAnnouncementSlider() {
  if (!window.announcementSettings) return;

  var swiper = new Swiper(".M-announcement-slider", {
    autoplay: {
      delay: window.announcementSettings.autoSpeed, 
    },
    speed: window.announcementSettings.dragSpeed,
    loop: true,
    slidesPerView: 1,
  });
}

function initializeReviewsSwiper() {
  var swiper = new Swiper(".reviews-umySwiper", {
    spaceBetween: 15,
    slidesPerView: 3,
    speed: 400,
    pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
      },
    breakpoints: {
      348: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 15,
      }
    }
  });
}